module.exports = __webpack_public_path__ + "static/media/bg5.4c0020de.png";